import React from 'react';

const AppLoader = () => {
    return (
        <div className="nurse-loader-overlay" role="status" aria-live="polite">
            <div className="nurse-loader-card">
                <div className="nurse-spinner nurse-spinner-lg" aria-hidden="true">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <p className="nurse-loader-text">Loading</p>
            </div>
        </div>
    );
};

export default AppLoader;
